import { Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '@catch/services';
import { DateTime } from 'luxon';
import { DpDatePickerModule, IDatePickerConfig } from 'ng2-date-picker';
import { FontawesomeService } from '../../../services/fontawesome.service';

/**
 * Input component that is attached to a {@link FormControl} and uses {@link IDatePickerComponent} to pick and select a date
 */
@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [LanguageService],
  imports: [ReactiveFormsModule, DpDatePickerModule, TranslocoPipe, FaIconComponent],
})
export class DateInputComponent {
  public readonly fontawesomeService = inject(FontawesomeService);
  private readonly languageService = inject(LanguageService);

  control = input.required<FormControl<number>>();
  submitAttempt = input(false);
  datePickerConfig = input<IDatePickerConfig>({
    format: 'DD.MM.YYYY',
    firstDayOfWeek: 'mo',
    min: DateTime.now().toFormat('dd.MM.yyyy'),
  });
  placeholder = input('');

  public date = new FormControl();

  onChange() {
    const ctrl = this.control();
    if (!this.date.value) {
      ctrl.patchValue(null);
      return;
    }
    ctrl.patchValue(
      DateTime.fromFormat(this.date.value, 'dd.MM.yyyy').toUnixInteger() ?? null
    );
    ctrl.patchValue(
      Number.isNaN(ctrl.value) ? null : ctrl.value
    );
  }
}
